/* @jsx h */
import { api } from "@app/data/index";
import { Order } from "@lemmonhq/types";
import { defineComponent, ref, watch, h } from "vue";
import { NotesModal } from "./NotesModal";
import { CartInner, CartProps } from "./CartInner";

export const CartComponent = defineComponent<CartProps>({
  name: "CartComponent",
  props: [
    "cart",
    "cartAPI",
    "onClear",
    "onIncrement",
    "onDecrement",
    "onRemove",
    "onUpdateNotes",
    "onUpdateCart",
    "services",
    "products",
    "selectedTable",
    "selectedService",
    "selectedCategory",
    "onServiceSelect",
    "onCategorySelect",
    "onProductSelect",
    "notes",
    "isNotesModalOpen",
    "isTableSelectModalOpen",
    "foodTypes",
  ],
  setup(props) {
    const tableOrders = ref<Order[]>([]);
    const isLoadingOrders = ref(false);

    const fetchTableOrders = async () => {
      if (!props.selectedTable.value) return;

      isLoadingOrders.value = true;
      try {
        const orderIds = props.selectedTable.value?.orders.map(
          (order) => order.id,
        );
        if (orderIds.length) {
          const orders = await api.getOrders(orderIds);
          tableOrders.value = orders;
        }
      } catch (error) {
        console.error("Failed to fetch table orders:", error);
      } finally {
        isLoadingOrders.value = false;
      }
    };

    watch(() => props.selectedTable.value, fetchTableOrders, {
      immediate: true,
    });
    const { isNotesModalOpen, isTableSelectModalOpen } = props;

    return () => (
      <div class="flex flex-col flex-1 h-full  ">
        <div class="flex flex-col flex-1 rounded [background:var(--pos-panel-bg)] border w-full rounded rounded-xl overflow-hidden">
          <CartInner
            {...props}
            isLoadingOrders={isLoadingOrders}
            isNotesModalOpen={isNotesModalOpen}
            isTableSelectModalOpen={isTableSelectModalOpen}
            tableOrders={tableOrders}
          />
        </div>
        {isNotesModalOpen.value ? (
          <NotesModal
            notes={props.notes}
            items={props.cart.items}
            isOpen={isNotesModalOpen.value}
            onClose={() => (isNotesModalOpen.value = false)}
            onSave={props.onUpdateNotes}
          />
        ) : null}
      </div>
    );
  },
});
